{
  "name": "qx-app",
  "description": "Applicazione Ibrida - Qx",
  "version": "1.0.07",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "set-registry": "npm config set registry https://registry.npmjs.org/",
    "prepare": "husky install",
    "precommit-script": "npx lint-staged --allow-empty",
    "eslintfix": "eslint --fix .",
    "disabled-web-security": "open -n -a /Applications/Google\\ Chrome.app/Contents/MacOS/Google\\ Chrome --args --user-data-dir=\"/tmp/chrome_dev_test\" --disable-web-security",
    "copy-develop-webmanifest": "cp src/manifest.develop.webmanifest src/manifest.webmanifest",
    "copy-master-webmanifest": "cp src/manifest.master.webmanifest src/manifest.webmanifest",
    "compodoc": "cd scripts && sh compodoc.sh",
    "analyze": "ng build application --stats-json --output-hashing none --named-chunks && esbuild-visualizer --template sunburst --metadata build/internal/stats.json --filename build/internal/analyze/index.html && http-server -o -c-1 ./build/internal/analyze/",
    "analyze:sme": "ng build application --source-map --output-hashing none --named-chunks && source-map-explorer build/internal/browser/*.js --html build/internal/sme/index.html && http-server -o -c-1 ./build/internal/sme/",
    "analyze:deps": "madge src/main.ts --ts-config tsconfig.json --image ./application-dep-graph.png",
    "detect-circular-injection": "npx madge --circular --extensions ts ./"
  },
  "private": true,
  "dependencies": {
    "@angular-eslint/schematics": "19.1.0",
    "@angular/animations": "19.1.7",
    "@angular/common": "19.1.7",
    "@angular/forms": "19.1.7",
    "@angular/localize": "19.1.7",
    "@angular/platform-browser": "19.1.7",
    "@angular/platform-browser-dynamic": "19.1.7",
    "@angular/router": "19.1.7",
    "@angular/service-worker": "19.1.7",
    "@capacitor/app": "7.0.0",
    "@capacitor/clipboard": "7.0.0",
    "@capacitor/core": "7.0.1",
    "@capacitor/device": "7.0.0",
    "@capacitor/haptics": "7.0.0",
    "@capacitor/keyboard": "7.0.0",
    "@capacitor/network": "7.0.0",
    "@capacitor/screen-orientation": "7.0.0",
    "@capacitor/splash-screen": "7.0.0",
    "@capacitor/status-bar": "7.0.0",
    "@ionic/angular": "^8.4.3",
    "@ionic/storage": "4.0.0",
    "@ionic/storage-angular": "4.0.0",
    "@ngx-translate/core": "16.0.4",
    "bowser": "2.11.0",
    "detectincognitojs": "1.3.7",
    "lodash": "4.17.21",
    "ngx-socket-io": "4.8.4",
    "ngx-translate-multi-http-loader": "19.0.2",
    "nosleep.js": "0.12.0",
    "rxjs": "7.8.1",
    "tslib": "2.8.1",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.1.8",
    "@angular-eslint/builder": "19.1.0",
    "@angular-eslint/eslint-plugin": "19.1.0",
    "@angular-eslint/eslint-plugin-template": "19.1.0",
    "@angular-eslint/template-parser": "19.1.0",
    "@angular/cli": "19.1.8",
    "@angular/compiler": "19.1.7",
    "@angular/compiler-cli": "19.1.7",
    "@angular/core": "19.1.7",
    "@angular/language-service": "19.1.7",
    "@capacitor/cli": "7.0.1",
    "@compodoc/compodoc": "1.1.26",
    "@eslint/compat": "1.2.6",
    "@eslint/eslintrc": "3.2.0",
    "@eslint/js": "9.20.0",
    "@ionic/angular-toolkit": "12.1.1",
    "@types/jasmine": "5.1.6",
    "@types/jasminewd2": "2.0.13",
    "@types/lodash": "4.17.15",
    "@types/node": "22.13.4",
    "@typescript-eslint/eslint-plugin": "8.24.1",
    "@typescript-eslint/parser": "8.24.1",
    "eslint": "9.20.1",
    "eslint-config-prettier": "10.0.1",
    "eslint-plugin-import": "2.31.0",
    "eslint-plugin-jsdoc": "50.6.3",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-prettier": "5.2.3",
    "globals": "15.15.0",
    "husky": "9.1.7",
    "jasmine-core": "5.6.0",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "lint-staged": "15.4.3",
    "madge": "8.0.0",
    "prettier": "3.5.1",
    "pretty-quick": "4.0.0",
    "protractor": "7.0.0",
    "stylelint": "16.14.1",
    "stylelint-config-recommended-scss": "14.1.0",
    "stylelint-scss": "6.11.0",
    "ts-node": "10.9.2",
    "typescript": "5.7.3"
  },
  "maintainers": [
    {
      "name": "Mathilda Monni",
      "email": "mathilda.monni@cambieri.it"
    },
    {
      "name": "Lorenzo Serravite",
      "email": "lorenzo.serravite@cambieri.it"
    }
  ],
  "repository": {
    "type": "git",
    "url": "https://dev.azure.com/cambieri/B.A.I.%20Technologies",
    "directory": "qx-app"
  },
  "homepage": "https://dev.azure.com/cambieri/B.A.I.%20Technologies",
  "bugs": {
    "url": "https://dev.azure.com/cambieri/B.A.I.%20Technologies"
  },
  "lint-staged": {
    "linters": {
      "*.ts": [
        "compodoc --coverageMinimumPerFile 25"
      ]
    }
  },
  "optionalDependencies": {
    "@nx/nx-darwin-arm64": "20.3.3",
    "@nx/nx-darwin-x64": "20.3.3",
    "@nx/nx-linux-x64-gnu": "20.3.3",
    "@nx/nx-win32-x64-msvc": "20.3.3"
  }
}
